import api, {
  PaginateRequest,
  PaginateResponse,
  ResponseCallback
} from '../services/api.service'
import routeUtil from '../utils/route.util'
import { ItemData } from './item.api'
import { PurchaseOrderData } from './purchaseOrder.api'

export interface PurchaseOrderItemData {
  id: number
  purchaseOrderId: number
  itemId: number
  deletedBy?: number
  quantity: number
  deletedAt?: string
  receivedQuantity: number
  remainingQuantity: number
  isDeleted: boolean
  purchaseOrder?: PurchaseOrderData
  item?: ItemData
}

type PurchaseOrderItemPaginateResponse = PaginateResponse<PurchaseOrderItemData[]>

export interface PurchaseOrderItemUpdateRequest {
  line?: string
  quantity?: number
  deliveryDate?: string
  vendorSite?: string
}

const routes = {
  paginate: '/purchaseOrderItems/paginate',
  delete: '/purchaseOrderItems/{id}',
  read: '/purchaseOrderItems/{id}',
  update: '/purchaseOrderItems/{id}'
}

export default {
  paginate (
    params: PaginateRequest,
    callback: ResponseCallback<PurchaseOrderItemPaginateResponse>
  ) {
    api.get(routes.paginate, params, callback)
  },

  delete (
    id: number,
    callback: ResponseCallback<PurchaseOrderItemData>
  ) {
    const url = routeUtil.replaceParams(routes.delete, { id })
    api.delete(url, {}, callback)
  },

  read (id: number, callback: ResponseCallback<PurchaseOrderItemData>) {
    const url = routeUtil.replaceParams(routes.read, { id })
    api.get(url, {}, callback)
  },

  update (
    id: number,
    payload: PurchaseOrderItemUpdateRequest,
    callback: ResponseCallback<PurchaseOrderItemData>
  ) {
    const url = routeUtil.replaceParams(routes.update, { id })
    api.patch(url, payload, callback)
  }
}
